<template>
  <div>
    <!-- 列表数据 -->
    <div class="content-list expertIntroduction">
      <!-- 列表数据 -->
      <van-list
          v-model="pageParams.loading"
          :finished="pageParams.finished"
          :finished-text="bottomText"
          class="vant-list"
          error-text="请求失败，点击重新加载"
          @load="getDoctorList"
      >
        <!-- 列表数据 -->
        <div class="content-big">
          <div
              v-for="(item, index) in dataList"
              :key="index"
              class="doctor-info"
              @click="jumpBjdoctor(item)"
          >
            <div v-lazy:background-image="item.imgUrl" class="info-img">
              <img :src="foodPlay" alt=""/>
              <div v-if="item.tag">{{ item.tag }}</div>
            </div>
            <div class="doctor-info-right">
              <p>{{ item.name }}</p>
              <div>
                <span class="bottomItem"
                ><img
                    class="icon"
                    src="./../../../assets/images/food/browse.png"
                /><span>{{ fomatterNum(item.playNum) || 0 }}</span></span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="canvasposter" @touchmove.prevent @mousewheel.prevent>
          <div class="share_box">
            <img
                :src="src"
                alt=""
                class="share-image"
                @touchend="posterSaveEnd($event)"
                @touchstart="posterSaveStart($event)"
            />
            <canvasPoster
                :painting="painting"
                class="poster"
                @fail="fail"
                @success="success"
            >
            </canvasPoster>
          </div>
        </div>
      </van-list>
      <foodVedio
          ref="childVideo"
          :showVedio="showVedio"
          :userInfo="userInfo"
          :videoDetail="dataInfo"
          :videoId="dataInfo.id"
          isHfindex="true"
          @cancelCollection="cancelCollection"
          @addCollection="addCollection"
          @hideVedio="hidevedioEvent"
          @isUserLogin="isUserLogin"
          @playerBuriedpoint="playerBuriedpoint"
          @switchoverVideoNext="switchoverVideoNext"
          @switchoverVideoPrev="switchoverVideoPrev"
      />
    </div>
    <login-tip
        :show="checkLogin"
        @cancleWay="cancleWay"
        @confirmWay="confirmWay"
    ></login-tip>
  </div>
</template>

<script>
import canvasPoster from "@/components/poster/doctor-canvas-poster.vue"; //疫情星妈课堂海报
import foodVedio from "../../../views/contents/bjfamousdoctor/component/video.vue"; //京城视频
import * as until from "@/assets/js/common.js"; //公共方法
import {fomatterNum, getCookie, is_weixin, isUserLogin} from "@/assets/js/common.js";
import goBack from "@/components/common/goBack"; //返回组件
import loginTip from "@/views/contents/calendar/component/logintip"; //注册提示组件
import API from "@/utils/axiosApi/catipaldoctorApi"; //api
import {Toast} from "vant";

export default {
  name: "bjDoctor",
  components: {
    foodVedio,
    goBack,
    loginTip,
    canvasPoster,
  },
  props: [],
  data() {
    return {
      categoryLabels: [],
      checkLogin: false, //跳转登录弹框
      playStatus: false,
      foodPause: require("@assets/images/food/food_pause.png"),
      foodPlay: require("@assets/images/bjDoctor/play.png"),
      showVedio: false,
      dataInfo: {},
      dataList: [], //列表数据
      bottomText: "",
      // 分页参数
      pageParams: {
        page: 1,
        size: 25,
        error: false,
        loading: false, //是否加载
        finished: false, //到底提示
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      showBack: true,
      isDiamonds: false,
      painting: {},
      src: "",
      dataAll: [],
      totalElements: 0, //数据总数
      collectIDS:[], // 收藏id集合
      removeCollectData: {}, //收藏的收藏集合
    };
  },
  computed: {
    isGoLogin() {
      return until.isUserLogin();
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.is_weixin()) {
        if (
            vm.getCookie("xmh_openid") == null ||
            vm.getCookie("xmh_openid") == ""
        ) {
          //判断有没有openId
          location.href =
              "/xmh/v2/wechat/oauth2/authorize?url=" +
              encodeURIComponent(window.location.href);
        } else {
        }
      }
      // 缓存页面
      vm.$store.commit("changeIncludes", ["bjDoctor"]);
    });
  },
  watch: {},
  created() {
  },
  mounted() {
    this.initPage();
    this.jumpId = this.$route.params.tojump;
    this.showBack =
        this.$route.query.crmId || this.$route.query.crmId == "" ? false : true;
    var shareDataParams = {
      shareLink: this.$http.hostName + "/home",
      shareDesc: "超1000万中国家庭都在看，快乐育儿，全程陪伴，源于母爱。",
      shareTitle: "星妈会-京城名医",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
  methods: {
    is_weixin,
    fomatterNum,
    getCookie,
    getmotherState: until.getmotherState,
    initPage() {
      // this.getDoctorList();
    },
    initFn() {
      this.pageParams.finished = false;
      this.pageParams.error = false;
      this.pageParams.loading = false;
      this.pageParams.page = 1;
      this.dataAll = [];
      this.dataList = []
    },
    // 切换上一个
    switchoverVideoPrev(id) {
      let index = this.dataAll.findIndex((item) => {
        return item.id === id;
      });
      if (index <= 0) {
        Toast("已是最新内容");
      } else {
        this.getDoctorDetail(this.dataAll[index - 1]);
        // this.dataInfo = this.dataAll[index - 1];
      }
    },
    // 切换下一个
    switchoverVideoNext(id) {
      let index = this.dataAll.findIndex((item) => {
        return item.id === id;
      });
      if (
          this.totalElements > this.dataAll.length &&
          index == this.dataAll.length - 1
      ) {
        this.getDoctorList(index);
      } else {
        console.log(index, this.dataAll);
        if (index >= this.dataAll.length - 1) {
          Toast("暂无更多内容");
        } else {
          this.getDoctorDetail(this.dataAll[index + 1]);
          // this.dataInfo = this.dataAll[index + 1];
        }
      }
    },
    // 星妈课堂疫情
    posterSaveStart: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
    },
    posterSaveEnd: function (e) {
      e.stopPropagation();
      clearTimeout(this.posterTime);
    },
    // 星妈课堂疫情海报保存
    success(src) {
      this.src = src;
    },
    fail(err) {
      console.log("fail", err);
    },
    // 返回
    goBack() {
      this.$router.push("/home");
    },
    // 获取列表数据
    getDoctorList(index, callBack) {
      API.catipalDcotorCollectLst(
          {},
          {
            crmId: until.getUserInfo(),
            page: this.pageParams.page,
            size: this.pageParams.size,
          },
          (res) => {
            if (res.code == 200) {
              const {total, data} = res.data;
              this.totalElements = total;
              this.dataList = [...this.dataList, ...data];
              if (this.dataList.length >= total) {
                this.pageParams.finished = true;
                this.bottomText = "——已经到底了哦——";
              } else {
                this.pageParams.loading = false; //加载状态取消
                this.pageParams.page++;
              }
              if (this.pageParams.page == 1 && total == 0) {
                this.$emit('isEmpty', true);
                this.bottomText = ""
              }
              this.dataAll = JSON.parse(JSON.stringify(this.dataList));
              if (index) {
                this.getDoctorDetail(this.dataAll[index + 1]);
              }


            } else {
              this.$toast("网络异常");
              this.pageParams.loading = false;
              this.pageParams.finished = true;
              this.pageParams.error = true;
            }
          }
      );
    },
    // 跳转京城名医详情
    jumpBjdoctor(item) {
      console.log(item);
      this.getDoctorDetail(item);
    },
    // 获取详情
    getDoctorDetail(item) {
      const {code} = this.getmotherState();
      API.catipalDcotorDetailNew({}, {id: item.id, crmId: until.getUserInfo(), memberLevelCode: code},
          (res) => {
            if (res.code === 200) {
              console.log(res);
              if (!res.data) {
                this.$toast("课程已下架");
                this.pageParams.page = 1;
                this.getDoctorList();
                return false;
              }
              this.dataInfo = res.data;
              this.playVedio();
            }
          }
      );
    },
    playVedio() {
      // this.dataInfo = this.PromotionalVideo
      this.clearTime(); //第二天清除时间
      this.playStatus = !this.playStatus;
      if (this.playStatus) {
        this.showVedio = true;

        // this.$refs.childVideo.initPlayer();
      }

      console.log(this.playStatus);
      console.log("播放");
    },
    // 第二天清除时间
    clearTime() {
      const end = new Date(
          new Date(new Date().toLocaleDateString()).getTime() +
          24 * 60 * 60 * 1000 -
          1
      ).getTime(); //存一下当天23：59：59秒
      const start = new Date().getTime(); //现行时间戳
      if (localStorage.getItem("endTime")) {
        if (start > localStorage.getItem("endTime")) {
          localStorage.removeItem("foodCurrentTime");
          localStorage.removeItem("saveFoodGroth"); //清除本地已看视频id 第二天从头播放
          localStorage.setItem("endTime", end);
        }
      } else {
        localStorage.setItem("endTime", end);
      }
    },
    // 视频播放返回按钮
    hidevedioEvent() {
      this.showVedio = false;
      this.playStatus = false;
    },
    // 播放埋点
    playerBuriedpoint({num, total, percent}) {
      this.playIndex++;
      if (this.playIndex == 1) {
        sensors.track("Audio_and_video_playback", {
          content_id: this.dataInfo.id,
          content_title: this.dataInfo.name,
          length_of_time: total,
          position: 0,
          content_topic: "宣传片",
          Membership_level: this.getmotherState().name,
          video_duration: num,
          is_finished: percent >= 0.8 ? true : false,
          Content_column: "京城名医",
        });
      }
    },
    isUserLogin() {
      if (isUserLogin()) {
        this.$refs.childVideo.Player.pause();
        this.checkLogin = true;
      }
    },
    // 确认
    confirmWay() {
      this.checkLogin = false;
      this.$refs.childVideo.isLogin();
      this.loginRegistSensors("确定");
    },
    // 取消
    cancleWay() {
      this.$refs.childVideo.Player.pause();
      this.$refs.childVideo.Player.currentTime = 9;
      this.checkLogin = false;
      this.loginRegistSensors("取消");
    },
    loginRegistSensors(msg) {
      sensors.track("Login_registration_pop_up", {
        operation: msg,
        page_name: "京城名医",
      });
    },
    // 添加收藏
    addCollection(id){
      if(this.collectIDS.includes(id)){
        this.dataList.splice(this.removeCollectData[id].index,0,this.removeCollectData[id].data)
      }
    },
    // 取消收藏
    cancelCollection(id) {
      this.collectIDS.push(id)
      const arr = new Set([...this.collectIDS])
      this.collectIDS = Array.from(arr)
      let index = this.dataList.findIndex(item => {
        return item.id == id
      })
      this.removeCollectData[id] = {
        data:this.dataList[index],
        index:index
      }
      this.dataList.splice(index, 1)
      if (this.dataList.length < 1) {
        this.$emit("isEmpty", true)
        this.bottomText = ""
      }
    }
  },
};
</script>

<style lang="less" scoped>
/deep/ .van-loading {
  background: #ffff;
}

// 疫情星妈课堂海报
.canvasposter {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 1000;

  .share_box {
    width: 254px;
    height: 454.5px;
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    margin: auto;

    .share-image {
      position: absolute;
      width: 254.5px;
      height: auto;
      z-index: 1000;
    }
  }
}

//列表数据
.content-list {
  // padding-top: 16px;
  width: 100%;
  box-sizing: border-box;

  .content-big {
    // margin-bottom: 20px !important;
    width: 351px;
    margin: 0 auto;
    box-sizing: border-box;
    // background: #ffffff;
    border-radius: 8px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;

    > .doctor-info {
      position: relative;

      &:nth-child(-n + 2) {
        margin-top: 16px;
      }

      & {
        margin-top: 7px;
      }

      width: 172px;
      height: 180px;
      background: #ffffff;
      box-shadow: 0px 8px 40px 0px rgba(0, 0, 0, 0.04);
      border-radius: 4px;
      // background-size: 100% 100%;
      > .info-img {
        position: relative;
        width: 172px;
        height: 92px;
        border-radius: 4px 4px 0 0;
        background-size: 100% 100%;

        img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 30px;
          height: 30px;
        }

        div {
          position: absolute;
          min-width: 30px;
          height: 16px;
          background: linear-gradient(270deg, #d4a437 0%, #e5bf5d 100%);
          border-radius: 4px 0px 4px 0px;
          font-size: 10px;
          color: #ffffff;
          line-height: 16px;
          text-align: center;
          padding: 0 5px;
        }
      }

      > .doctor-info-right {
        margin-left: 10px;
        // height: 100px;
        // background: red;
        // float: left;
        > p {
          margin-top: 7px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 21px;
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          line-clamp: 2;
          -webkit-box-orient: vertical;
        }

        > .over-text {
          margin-top: 10px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #d4a437;
          line-height: 18px;
        }

        .bottomItem {
          line-height: 20px;
          font-size: 12px;
          color: #999;

          .icon {
            width: 12px;
            height: 10px;
            margin-right: 3px;
            vertical-align: middle;
          }

          .icon1 {
            width: 10px;
          }

          span {
            vertical-align: -9%;
          }
        }

        > div {
          width: 162px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: absolute;
          bottom: 8px;

          > div {
            span:nth-of-type(1) {
              margin-right: 7px;
              box-sizing: border-box;
              display: block;
              text-align: center;
              width: 50px;
              height: 26px;
              border: 1px solid #d4a437;
              color: #e0b76b;
              border-radius: 24px;
              font-size: 12px;
              font-weight: 500;
              line-height: 26px;
            }

            span:nth-of-type(2) {
              display: block;
              text-align: center;
              width: 78px;
              height: 26px;
              background: linear-gradient(270deg, #d4a437 0%, #e5bf5d 100%);
              border-radius: 24px;
              font-size: 12px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              line-height: 26px;
            }
          }
        }
      }
    }
  }
}
</style>
